<template>
  <div class="ypo-concierge-layout" @click.stop="handleConciergeInitiation(true)">
    <div v-if="chatInitializationInProgress" class="ypo-concierge-layout__loading">
      <v-progress-circular class="ypo-concierge-layout__loading--spinner" color="primary" indeterminate></v-progress-circular>
    </div>
    <div class="ypo-concierge-layout__title">
      <div class="ypo-concierge-layout__title--main">{{ ypoConciergeConstant.TITLE }}</div>
      <div class="ypo-concierge-layout__title--sub">{{ ypoConciergeConstant.SUB_TITLE }}</div>
    </div>
    <div class="ypo-concierge-layout__options">
      <div class="concierge-option" @click="requestAssistanceClick">
        <div class="concierge-option__icon concierge-option__icon--assistance">
          <icon-ypo-concierge height="21" width="21" custom-class="fill_ypo_blue"></icon-ypo-concierge>
        </div>
        <div class="concierge-option__label">{{ ypoConciergeConstant.REQUEST_ASSISTANCE_TITLE }}</div>
      </div>
      <div class="concierge-option" @click="requestM2MxClick">
        <div class="concierge-option__icon concierge-option__icon--assistance">
          <img src="../../assets/m2mxLogo.png" height="24" width="24" custom-class="fill_ypo_blue"></img>
        </div>
        <div class="concierge-option__label">{{ ypoConciergeConstant.M2MX_OPTION }}</div>
      </div>
      <div v-if="displayChatLink" class="concierge-option"
           @click="startConciergeChat">
        <div class="concierge-option__icon"><i class="far fa-comments"></i></div>
        <div class="concierge-option__label">{{ ypoConciergeConstant.CHAT_TITLE }}</div>
      </div>
      <div  class="concierge-option">
        <div class="concierge-option__icon concierge-option__icon--phone"><i class="fas fa-mobile-alt"></i></div>
        <div class="concierge-option__label">
          <a :href="`tel:${ypoConciergeConstant.PHONE_NUMBER}`" @click="trackCallTriggered">
            {{ phoneNumber }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { trackEventConstant } from "../../plugins/analytics.constant";
import { storeGetters } from "@/store/storeGetters.constant";
import { storeMutation } from "@/store/storeMutations.constant";
import StatusOverlay from "@/components/StatusOverlay/StatusOverlay";
import { ypoConciergeConstant } from "./ypoConcierge.constant";
import IconYpoConcierge from "../Icons/IconYpoConcierge";
import { gaDataLayerEvent } from "@/plugins/analytics";
import { gtmEventName } from "@/plugins/gtmAnalytics";
import { commonEnvVariables } from "@/commonEnvVariables";

export default {
  name: 'YpoConciergeLayout',
  components: { StatusOverlay, IconYpoConcierge },
  props: {
    handleYpoConciergeHelpInitiated: {
      type: Function,
    },

  },
  data() {
    return {
      ypoConciergeConstant,
      trackEventConstant,
      chatInitializationInProgress: false,
      commonEnvVariables,
    };
  },
  methods: {
    ...mapMutations({
      setConciergeActiveStatue: `ypoConciergeService/${storeMutation.setConciergeActiveStatue}`,
    }),
    handleConciergeInitiation(val) {
      if (this.handleYpoConciergeHelpInitiated) this.handleYpoConciergeHelpInitiated(val);
    },
    startConciergeChat() {
      if (this.conciergeScriptLoaded && this.isYpoConciergeAgentAvailable) {
        this.chatInitializationInProgress = true;
        window.embedded_svc.addEventHandler("afterinitialization", () => {
          this.setConciergeActiveStatue(true);
          this.chatInitializationInProgress = false;
          this.handleConciergeInitiation(false);
        });
        window.embedded_svc.bootstrapEmbeddedService();
      }
    },
    closeYpoHelp() {
      setTimeout(() => {
        this.handleConciergeInitiation(false);
      }, 300);
    },
    requestAssistanceClick() {
      window.open(commonEnvVariables().VUE_APP_YPO_SF_ASSISTANCE_URL, this.isMobileAppBrowser ? '_self' : '_blank');
      gaDataLayerEvent(gtmEventName.C_Connect_Ask_Concierge, this.currentUserId);
      this.closeYpoHelp();
    },
    requestM2MxClick() {
      window.open(commonEnvVariables().VUE_APP_YPO_M2MX_ASSISTANCE_URL, this.isMobileAppBrowser ? '_self' : '_blank');
      this.closeYpoHelp();
    },
    trackCallTriggered() {
      gaDataLayerEvent(gtmEventName.C_Connect_Call_Concierge, this.currentUserId);
    },
  },
  computed: {
    ...mapState('actionState', ['actions']),
    ...mapGetters({
      isYpoConciergeAgentAvailable: `ypoConciergeService/${storeGetters.isYpoConciergeAgentAvailable}`,
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
      currentUserId: `auth/${storeGetters.currentUserId}`,
      conciergeScriptLoaded: `ypoConciergeService/${storeGetters.isConciergeScriptLoaded}`,
      isConciergeActive: `ypoConciergeService/${storeGetters.isConciergeActive}`,
    }),
    phoneNumber() {
      return `${this.ypoConciergeConstant.PHONE} ${this.ypoConciergeConstant.PHONE_NUMBER}`;
    },
    displayChatLink() {
      return this.conciergeScriptLoaded && this.isYpoConciergeAgentAvailable && !this.isConciergeActive;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../common/styles/_colors.scss';
@import '../../common/styles/_commonClasses.scss';
@import '../../common/styles/_responsive.scss';

.ypo-concierge-layout {
  border-radius: 4px;
  min-height: 135px;
  width: 275px;
  background-color: $white;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);

  &__title {
    background-color: $ypo-blue;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    margin-left: -1px;
    color: $white;
    padding: 10px 15px;

    &--main {
      font-size: 19px;
      margin-left: 1px;
    }

    &--sub {
      font-size: 11px;
      padding-top: 7px;
    }
  }

  &__loading {
    position: absolute;
    height: 80%;
    width: 100%;
    top: 50px;
    opacity: 0.9;
    background-color: $white;
    z-index: 2;

    &--spinner {
      position: absolute;
      top: 30%;
      left: 40%;
    }
  }

  .concierge-option {
    border-top: 1px solid $ypo-medium-gray;
    height: 45px;
    width: 100%;
    padding: 7px 20px 10px;
    cursor: pointer;
    color: $ypo-blue;
    display: flex;

    &__icon {
      font-size: 20px;
      margin-right: 15px;

      &--assistance {
        padding-top: 3px;
      }
      &--phone {
        padding-left: 5px;
        padding-right: 3px;
      }
    }

    &__label {
      font-size: 13px;
      font-weight: 600;
      padding-top: 5px;

      & a {
        text-decoration: none;
        color: $ypo-blue;

        &:hover {
          color: $ypo-cta;
        }
      }
    }

    &:hover {
      .concierge-option__label {
        color: $ypo-cta;
      }
    }
  }
}
</style>

